import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const MARK = {
    true: { ch: '✓', color: 'success.main' },
    false: { ch: '✗', color: 'error.main' },
    null: { ch: '·', color: 'text.secondary' },
};

/**
 * Why a parking can be the car: ✓ for, ✗ against, · information. Never a percentage (similarity alone proves nothing)
 */
export default function Reasons({ reasons, dense }) {
    if (!reasons || !reasons.length) return null;
    return (
        <Stack spacing={dense ? 0 : 0.25}>
            {reasons.map((r) => {
                const m = MARK[r.ok === true || r.ok === false ? r.ok : null];
                return (
                    <Typography
                        key={r.text}
                        variant="body2"
                        component="div"
                        sx={{ fontSize: dense ? 12 : 13 }}
                    >
                        <Box component="span" sx={{ color: m.color, fontWeight: 700, mr: 0.75 }}>
                            {m.ch}
                        </Box>
                        {r.text}
                    </Typography>
                );
            })}
        </Stack>
    );
}
